/**
 * The shortest password the API accepts, whether someone sets it for themselves or for a person
 * they add. Mirrored here so a form can say what is wrong before the round trip; the server
 * enforces it regardless.
 */
export const MINIMUM_PASSWORD_LENGTH = 8;
